export const apiUrl = 'https://api.parcapaketi.com/api';
//export const apiUrl = 'http://localhost:21021/api';

// export const messageApi = 'http://localhost:8080';


